import { ReactNode } from 'react';
import { PermissionAction, PermissionAsset } from '@redux/types/types';
import { UserRoles } from './enum/common';

export interface IUserMenuItem {
  label: string | ReactNode;
  key: string;
  link?: string;
  icon?: ReactNode;
  userAccess?: UserRoles[];
  permissions?: Partial<Record<PermissionAsset, PermissionAction>>;
}

export type IUserMenuSettings = IUserMenuItem[];

export const USER_MENU_SETTINGS: IUserMenuSettings = [
  {
    label: 'Personal Details',
    key: 'personalDetails',
    link: '/settings/personal-details',
    permissions: {},
  },
  {
    label: 'Organization',
    key: 'organization',
    link: '/settings/organization',
    permissions: {},
  },
  {
    label: 'Workspaces',
    key: 'workspaces',
    link: '/settings/workspaces',
    userAccess: [UserRoles.ADMIN],
    permissions: {},
  },
  // TODO: Add roles page when it's ready
  // {
  //   label: 'Roles',
  //   key: 'roles',
  //   link: '/settings/roles',
  //   userAccess: [UserRoles.ADMIN],
  // },
  {
    label: 'API Keys',
    key: 'apiKeys',
    link: '/settings/api-keys',
    userAccess: [UserRoles.ADMIN, UserRoles.EDITOR],
    permissions: {
      [PermissionAsset.API_KEYS]: PermissionAction.READ,
    },
  },
  {
    label: 'Integrations',
    key: 'integrations',
    link: '/settings/integrations',
    userAccess: [UserRoles.ADMIN],
    permissions: {},
  },
  {
    label: 'Secrets',
    key: 'secrets',
    link: '/settings/secrets',
    userAccess: [UserRoles.ADMIN],
    permissions: {},
  },
  {
    label: 'Usage',
    key: 'usage',
    link: '/settings/usage',
    userAccess: [UserRoles.ADMIN],
    permissions: {},
  },
  {
    label: 'Logout',
    key: 'logout',
    link: '/logout',
    permissions: {},
  },
];
